module.exports = __webpack_public_path__ + "img/stella-cropped.945add89.png";